<template>
  <div id="pop">
    <div class="module-dialog-layer" style="display: block"></div>
    <div class="module-dialog clear module-dialog-address module-dialog-show">
      <div class="dialog-panel">
        <div class="topbar">
          <div class="dialog-tit clear">
            <h4 class="js-dialog-title">管理收货地址</h4>
          </div>
          <span class="dialog-close" @click="close">x</span>
        </div>
        <div class="dialog-con js-dialog-container">
          <div class="animate-layer">
            <div class="dialog-inner js-address-add">
              <div class="save-address-box">
                <div class="address-form">
                  <div class="module-form-row">
                    <div class="form-item-v3">
                      <input
                        type="text"
                        class="js-verify"
                        placeholder="收货人姓名"
                        v-model.lazy="receive.name"
                        @blur="verifyName"
                        ref="name"
                      />
                      <div class="verify-error"></div>
                    </div>
                  </div>
                  <div class="module-form-row">
                    <div class="form-item-v3">
                      <input
                        type="text"
                        class="js-verify"
                        placeholder="手机号"
                        v-model.lazy="receive.phone"
                        @blur="verifyPhone"
                        ref="phone"
                      />
                      <div class="verify-error"></div>
                    </div>
                  </div>
                  <div class="module-form-row clear">
                    <div
                      class="form-item-v3 area-code-w fn-left form-valid-item"
                    >
                      <input
                        type="text"
                        style="width: 80px"
                        class="js-verify js-address-area-code"
                        placeholder="区号（可选）"
                        v-model.lazy="receive.areaCode"
                      />
                      <div class="verify-error"></div>
                    </div>
                    <div
                      class="form-item-v3 telephone-w fn-right form-valid-item"
                    >
                      <input
                        type="text"
                        style="width: 180px"
                        class="js-verify js-address-telephone"
                        placeholder="固定电话（可选）"
                        v-model.lazy="receive.landLine"
                      />
                      <div class="verify-error"></div>
                    </div>
                  </div>
                  <div class="module-form-row clear">
                    <div class="form-item-v3 select-item province-wrapper">
                      <select
                        name="province_code"
                        class="
                          province
                          select-province
                          js-form-province js-verify
                        "
                        v-model="provinceList"
                      >
                        <option value="0">请选择省份</option>
                        <option
                          :value="province"
                          v-for="province in addList"
                          :key="province.area_id"
                        >
                          {{ province.area_name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="module-form-row clear">
                    <div
                      class="
                        form-item-v3
                        select-item
                        city-wrapper
                        fn-left
                        form-focus-item
                      "
                    >
                      <select
                        class="city select-city js-form-city js-verify"
                        v-model="cityList"
                      >
                        <option value="0">请选择城市</option>
                        <option
                          :value="city"
                          v-for="city in provinceLists"
                          :key="city.area_id"
                        >
                          {{ city.area_name }}
                        </option>
                      </select>
                    </div>
                    <div
                      class="
                        form-item-v3
                        select-item
                        district-wrapper
                        fn-right
                        form-focus-item
                      "
                    >
                      <select
                        class="city select-city js-form-city js-verify"
                        v-model="receive.county"
                      >
                        <option value="0">请选择区县</option>
                        <option
                          :value="county.area_name"
                          v-for="county in cityLists"
                          :key="county.area_id"
                        >
                          {{ county.area_name }}
                        </option>
                      </select>
                    </div>
                  </div>
                  <div class="module-form-row">
                    <div class="form-item-v3">
                      <input
                        type="text"
                        class="js-verify"
                        v-model="receive.add"
                        placeholder="详细地址，如街道名称，楼层，门牌号码等"
                        @blur="verifyAdd"
                        ref="add"
                      />
                      <div class="verify-error"></div>
                    </div>
                  </div>
                  <div class="module-form-row fn-clear">
                    <input type="checkbox" class="hide" />
                    <span
                      class="blue-checkbox"
                      @click="onDefault($event)"
                    ></span
                    >设为默认
                  </div>
                  <div
                    class="dialog-blue-btn big-main-btn js-verify-address"
                    :class="{ 'disabled-btn': !verifyInfo }"
                  >
                    <a @click="saveInfo()">保存</a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import "@/assets/css/address-pop.css";
import addList from "@/lib/addList.js";
export default {
  data() {
    return {
      addList, //联动的省市县信息
      receive: {
        name: "",
        phone: "",
        areaCode: "",
        landLine: "",
        provinceId: 0,
        province: "",
        cityId: 0,
        city: "",
        countyId: 0,
        county: "",
        add: "",
        default: false,
      },
      provinceList: [],
      cityList: [],
      countyList: [],
      verifyInfo: false,
    };
  },
  methods: {
    close() {
      //子组件传值给父组件
      this.$emit("closePop", false);
    },
    onDefault(event) {
      if (!this.receive.default) {
        this.receive.default = true;
        event.target.style = "background-position: 0 -20px";
      } else {
        this.receive.default = false;
        event.target.style = "background-position: 0 0px";
      }
    },
    //判断名字是否合法
    verifyName() {
      var reg_user = /^[\u4e00-\u9fa5]{2,4}$/; //名字正则
      if (!reg_user.test(this.receive.name)) {
        this.$refs.name.focus();
        this.$refs.name.parentNode.style.border = "1px solid #f00";
      } else {
        this.$refs.name.parentNode.style.border = "1px solid #ccc";
      }
    },
    //判断电话是否合法
    verifyPhone() {
      var reg_tel =
        /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/; //电话号正则表达
      if (!reg_tel.test(this.receive.phone)) {
        this.$refs.phone.focus();
        this.$refs.phone.parentNode.style.border = "1px solid #f00";
      } else {
        this.$refs.phone.parentNode.style.border = "1px solid #ccc";
      }
    },
    verifyAdd() {
      var reg_add = /^[\u4e00-\u9fa5]{4,20}$/; //详细地址正则
      if (!reg_add.test(this.receive.add)) {
        this.$refs.add.focus();
        this.$refs.add.parentNode.style.border = "1px solid #f00";
      } else {
        this.$refs.add.parentNode.style.border = "1px solid #ccc";
      }
    },
    //提交表达信息
    saveInfo() {
      this.$store.commit("saveInfo", this.receive);
      this.$emit("closePop", false);
    },
  },
  created() {
    //select中初始化会是空白的，默认选中第一个
    this.provinceList = 0;
  },
  computed: {
    //省的信息
    provinceLists() {
      this.receive.provinceId = this.provinceList.area_id;
      this.receive.province = this.provinceList.area_name;
      this.cityList = 0; //select中初始化会是空白的，默认选中第一个
      return this.provinceList.city_list;
    },
    //市的信息
    cityLists() {
      this.receive.countyId = this.cityList.area_id;
      this.receive.city = this.cityList.area_name;
      this.receive.county = 0;//select中初始化会是空白的，默认选中第一个
      return this.cityList.county_list;
    },
  },
  watch: {
    //地址表单验证
    receive: {
      handler: function (newValue, oldValue) {
        var reg_user = /^[\u4e00-\u9fa5]{2,4}$/; //名字正则
        var reg_tel =
          /^(13[0-9]|14[01456879]|15[0-35-9]|16[2567]|17[0-8]|18[0-9]|19[0-35-9])\d{8}$/; //电话号正则表达
        var reg_add = /^[\u4e00-\u9fa5]{4,20}$/; //详细地址正则
        this.verifyInfo = false; //如果数据不合法则为false
        //验证名字是否合法
        if (!reg_user.test(newValue.name)) {
          return;
        }
        //验证电话号是否合法
        if (!reg_tel.test(newValue.phone)) {
          return;
        }
        //验证详细地址是否合法
        if (!reg_add.test(newValue.add)) {
          return;
        }
        if (newValue.province && newValue.city && newValue.county) {
          this.verifyInfo = true; //如果数据合法则为true
        }
      },
      deep: true,
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/components/address-pop.vue